/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Varun
 * Created Date: 08/21/2020
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
 * Ref: LN_PC_15
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from './MenuAction';
import * as CookieService from '../CookieService';
/**
 * Ref: LN_PC_16
 * 
 * pageLoad method gets called from the componentWillMount() of the component.
 * It takes a parameters loginPageLoadBO which is passed from the component file.
 * @param HomepageBO
 */
const pageLoad = (HomepageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Homepage,
            SDIConstants.methodNames.Homepage_Pageload,
            JSON.stringify(HomepageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        ;
                        let contentData = { type: SDIConstants.methodNames.Homepage_Pageload, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else if (data.success == false) {
                        if (data.response) {
                            if (data.response == SDIConstants.tokenExpired) {
                                MenuAction.tokenExpired();
                            }
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const GetMFG = (HomepageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Homepage,
            SDIConstants.methodNames.getPreFilterData,
            JSON.stringify(HomepageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        ;
                        let contentData = { type: SDIConstants.methodNames.getPreFilterData, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else if (data.success == false) {
                        if (data.response) {
                            if (data.response == SDIConstants.tokenExpired) {
                                MenuAction.tokenExpired();
                            }
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const getPreFilterData = (HomepageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Homepage,
            SDIConstants.methodNames.getPreFilterData,
            JSON.stringify(HomepageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        ;
                        let contentData = { type: "preFilter", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else if (data.success == false) {
                        if (data.response) {
                            if (data.response == SDIConstants.tokenExpired) {
                                MenuAction.tokenExpired();
                            }
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const getSearchSuggestions = async (searchBO) => {
    try {
        let responseData = "";
        await SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_SearchSuggestions,
            JSON.stringify(searchBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        responseData = data.response;
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
        return responseData;

    } catch (ex) {
        console.log(ex)
        return "";
    }
};

const getPassThroughAutheURl = (getPassThroughAutheURlBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.PassThroughAuthe,
            SDIConstants.methodNames.PassThroughAuthe_PassAutheInitialize,
            JSON.stringify(getPassThroughAutheURlBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PassThroughAuthe", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
//WW-839 As a Sam's Club User, I need to access Manufacturer's detailed parts diagrams and other associated asset documentation TECH VAULT - Deepthi N H
const WorkOrderCheck = async (WorkOrderBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(WorkOrderBO),
            (data) => {
                if (data.success) {

                    if (data.response != "" && data.response != "[]" && data.response != [] && data.response) {
                        let contentData = { type: "workordercheck", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else {
                        let contentData = { type: "workorderfail", response: "failed" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

/*[08/31/22 , PC_365_02]Tech Vault Search - Priyanka D*/

const TechVault = (TechVaultBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.TechVault,
            SDIConstants.methodNames.GetEncryptedCredentials,
            JSON.stringify(TechVaultBO),
            (data) => {
                /*[08/31/22 , PC_365_11]Tech Vault Search - Priyanka D*/

                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "TechVault", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
export {
    pageLoad, getSearchSuggestions, tokenExpired, GetMFG, getPassThroughAutheURl, TechVault, WorkOrderCheck, getPreFilterData
}